import type { SVGProps } from "react";
import { memo } from "react";
const Sumerian = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#B0084D" />
        <stop offset="100%" stopColor="#FF4F8B" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M65 19c0-2.243-1.757-4-4-4s-4 1.757-4 4 1.757 4 4 4 4-1.757 4-4m2 0c0 3.364-2.636 6-6 6s-6-2.636-6-6 2.636-6 6-6 6 2.636 6 6M57 62.063C57 59.785 55.243 58 53 58s-4 1.785-4 4.063C49 64.271 50.757 66 53 66s4-1.729 4-3.937m2 0C59 65.392 56.364 68 53 68s-6-2.608-6-5.937C47 58.72 49.691 56 53 56s6 2.72 6 6.063M20 33c2.243 0 4-1.757 4-4s-1.757-4-4-4-4 1.757-4 4 1.757 4 4 4m0 2c-3.364 0-6-2.636-6-6s2.636-6 6-6 6 2.636 6 6-2.636 6-6 6m16.396 7.198-4.267 2.608 1.043 1.706 4.266-2.608zm-5.783 5.879-1.043-1.706-4.266 2.608 1.043 1.706zm24.137.573-4.326-2.505-1.002 1.73 4.326 2.506zm-11.249-6.515-1.002 1.73 4.326 2.506 1.002-1.73zM39 29h2v-5h-2zm0 8h2v-5h-2zm24-8v25a1 1 0 0 1-.491.861l-4 2.364-1.018-1.722 2.525-1.492-3.671-2.127 1.002-1.73L61 52.271V30.68L41 41.594v23.64l3.485-2.091 1.03 1.714-5 3a.99.99 0 0 1-1.041-.007l-21-13A1 1 0 0 1 18 54V38h2v14.222l2.744-1.678 1.043 1.706-2.875 1.758L39 65.205V41.591L26.049 34.47l.963-1.753 12.99 7.143 19.969-10.898L41 17.752V21h-2v-3.21l-11.476 7.062-1.048-1.704 13-8a1 1 0 0 1 1.033-.009l22 13A1 1 0 0 1 63 29"
      />
    </g>
  </svg>
);
const Memo = memo(Sumerian);
export default Memo;
